import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Col, Container, Row } from "reactstrap";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import {
	EditorComponent,
	Input,
	Textarea,
} from "../../components/shared/FormComponentsNew";
import Loader from "../../components/shared/Loader";
import { getId } from "../../helpers";
import { getData, postData, putData } from "./getData";
import AddButton from "../../components/shared/AddButton";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import { useMemo } from "react";
import StatisticsArray from "./featuresArray";
import { DecoupledEditor } from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ImageUpload from "./ImageUpload";

const EditCategory = () => {
	const dispatch = useDispatch();

	const navigate = useHistory();
	const { id } = useParams();
	const categoryType = window.location.pathname?.split("/")?.at(-2);

	const [singleCategory, setSingleCategory] = useState({});
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(false);
	const [subCategories, setSubCategories] = useState([]);
	const [mainCategory, setMainCategory] = useState({});

	const [picture, setPicture] = useState();

	const mainCategories = useMemo(
		() => categories?.filter(category => !category?.category),
		[categories]
	);

	const {
		register,
		handleSubmit,
		reset,
		control,
		setValue,
		watch,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "تعديل التصنيف",
				breadcrumb: `اضافة تصنيف ${categoryType === "sub" ? "فرعي" : "اساسي"}`,
				button: {
					show: false,
				},
			})
		);
		init();
	}, [categoryType, dispatch]);

	useEffect(() => {
		let category = categories?.find(e => e?.slug === id);
		setSingleCategory(category);
		setPicture(category?.image);
	}, [categories, id]);

	const init = async () => {
		await getData({
			url: `/pages/categories`,
			setData: data => setCategories(data?.data?.page?.sections),
			setLoading,
		});
	};

	useEffect(() => {
		if (categoryType === "sub-child") {
			const subCategories = categories?.filter(
				category =>
					getId(category?.category) ===
					getId(
						categories?.find(e => getId(e) == getId(singleCategory?.category))
							?.category
					)
			);

			setSubCategories(subCategories);
		}
	}, [categories, categoryType, singleCategory?.category]);

	useEffect(() => {
		if (categoryType === "sub-child") {
			setMainCategory(
				getId(
					mainCategories?.find(e =>
						e?.subCategories?.find(
							sub => getId(sub) == getId(singleCategory?.category)
						)
					)
				)
			);
			const subCategories = categories?.filter(
				category =>
					getId(category?.category) ===
					getId(
						categories?.find(e => getId(e) == getId(singleCategory?.category))
							?.category
					)
			);
			setSubCategories(subCategories);
		}

		reset(singleCategory);
	}, [categories, categoryType, mainCategories, reset, singleCategory]);

	useEffect(() => {
		setValue("image", picture?.path || picture);
	}, [picture, setValue]);

	const handleSelectOptions = options => {
		if (options.length < 0) return [];

		return options.map(option => {
			return {
				value: option?.slug,
				label: option?.name?.ar,
			};
		});
	};

	const onSubmit = data => {
		putData({
			url: `pages/categories/sections/${id}`,
			body: { section: data },
			setLoading,
			setData: data => {
				// setCategories(data)
				navigate.push(`/categories/${categoryType}`);
			},
		});
	};

	if (loading) return <Loader />;

	let editor = null;

	return (
		<>
			<div className="acc-form">
				<div className="card">
					<div className="card-body">
						<form onSubmit={handleSubmit(onSubmit)}>
							<Col md={12}>
								{/* title  */}
								<ImageUpload
									selectedImage={picture}
									setSelectedImage={setPicture}
								/>
								<Row>
									<Col lg={6} xs={12}>
										<Input
											langId="الاسم"
											name="name.ar"
											register={register}
											errors={errors}
										/>
									</Col>
									<Col lg={6} xs={12}>
										<Input
											langId="الاسم"
											name="name.en"
											register={register}
											errors={errors}
										/>
									</Col>
								</Row>

								{/* description  */}
								<Row>
									<Col lg={6} xs={12}>
										{/* <Textarea
											langId="الوصف"
											name="description.ar"
											register={register}
											errors={errors}
										/> */}
										<EditorComponent
											langId="الوصف"
											name={`description.ar`}
											control={control}
											errors={errors}
										/>
									</Col>
									<Col lg={6} xs={12}>
										{/* <Textarea
											langId="الوصف"
											name="description.en"
											register={register}
											errors={errors}
										/> */}
										<EditorComponent
											langId="الوصف"
											name={`description.en`}
											control={control}
											errors={errors}
										/>
									</Col>
								</Row>
								{/* parert category */}
								{categoryType?.includes("sub") && singleCategory?.category && (
									<Row>
										<Col lg={12} xs={12}>
											<div className="form-group ">
												<h5>
													{" "}
													التصنيف الرئيسي
													{/* <FormattedMessage id={"mainCategory"} /> */}
												</h5>
												<div>
													<Controller
														control={control}
														render={({
															field: { onChange, value, name, ref },
														}) => (
															<Select
																inputRef={ref}
																name={name}
																placeholder="التصنيف الرئيسي"
																options={handleSelectOptions(mainCategories)}
																onChange={selectedOption => {
																	// -------------------------------------------------------

																	setSubCategories([]);

																	const subCategories = categories?.filter(
																		category =>
																			category?.category?._id ===
																			selectedOption?.value
																	);

																	setSubCategories(subCategories);
																	// --------------------------------
																	if (categoryType !== "sub-child")
																		onChange(selectedOption.value);
																}}
																isRtl={true}
																isSearchable={false}
																className="basic-single"
																classNamePrefix="select"
																value={handleSelectOptions(
																	mainCategories
																)?.find(e => e?.value == value)}
															/>
														)}
														name={"category"}
														rules={{
															required: categoryType === "sub" ? true : false,
														}}
													/>
												</div>
												<p className="error-hint">
													{
														errors?.category && "هذا الحقل مطلوب"
														// <FormattedMessage id={"requiredField"} />
													}
												</p>
											</div>
										</Col>
									</Row>
								)}

								<StatisticsArray
									{...{ control, register, errors, setValue, watch }}
								/>

								<AddButton data="حفظ" />
							</Col>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default EditCategory;
